import { render, staticRenderFns } from "./editarSemBotao.vue?vue&type=template&id=544e74dc&scoped=true"
import script from "./editarSemBotao.vue?vue&type=script&lang=js"
export * from "./editarSemBotao.vue?vue&type=script&lang=js"
import style0 from "./editarSemBotao.vue?vue&type=style&index=0&id=544e74dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544e74dc",
  null
  
)

export default component.exports